import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

export default function SuccessBlock ({ header, description }) {
  return (
    <div className={'p-4 br-3 d-flex flex-column gap-2 bg-light align-items-center mt-4'}>
      <div className={'text-success display-1'}>
        <FontAwesomeIcon
          icon={faCheckCircle}
          width={72}
          height={72}
          fixedWidth
        />
      </div>
      {header && (
        <div className={'fs-5 text-center'}>
          {header}
        </div>
      )}
      {description && (
        <div className={'fs-6 text-muted text-center'}>
          {description}
        </div>
      )}
    </div>
  )
}